/* eslint-disable import/prefer-default-export */
export const cryptodraftScreens = {
  PROMO: 'promo',
  CALCULATOR: 'calculator',
  DETAILS: 'details',
  WITHDRAW: 'withdraw',
  REVIEW: 'review',
  ADD_MORE_COLLATERAL: 'add_more_collateral',
  PROCEED_WITH_PAYMENT: 'proceed_with_payment',
  REVIEW_EXTEND_OFFER: 'review_extend_offer',
  SETTLE: 'settle',
  PAY_PARTIAL: 'pay_partial',
  INTEREST_PAYMENTS: 'interest_payments',
  WALLETS: 'wallets',
};

export const cryptodraftAllowedCurrencies = ['btc', 'eth'];

export const MoreCollateralPaymentMethod = {
  PGW: 'pgw',
  LEDGER: 'ledger',
};

export const forceUpdateOptions = {
  WALLETS: 'allowedWallets',
  DETAILS: 'cryptodraftDetails',
  SETTLEMENT_DETAILS: 'cryptodraftSettlementDetails',
};

export const forceResetOptions = {
  SETTLEMENT_MAIN_WALLET: 'selectedSettlementWallet',
};

export const HINTS_TOTAL_STEPS = 3;

export const SETTLMENT_INTREST_PAYMENT_AVAILABLE_CURRENCIES = [
  'BTC',
  'ETH',
  'USDT',
  'USDC',
  'EURT',
  'EUROC',
];
